export default "__VITE_ASSET__C9k_29rG__"